import { render, staticRenderFns } from "./FormR9.vue?vue&type=template&id=52bf0ede&scoped=true&"
import script from "./FormR9.vue?vue&type=script&lang=ts&"
export * from "./FormR9.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf0ede",
  null
  
)

export default component.exports